export default __webpack_public_path__ + "static/media/honeybee.ae6a4c23.jpg";